exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/chess.arska.org/chess/src/app/dashboard/dashboard.component.sass
// module id = ../../../../../src/app/dashboard/dashboard.component.sass
// module chunks = main